import styled from "styled-components";
import { theme } from "@tm/utility/global";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Container = styled.div<{ isFocused?: boolean }>`
  background: ${(p) => (p.isFocused ? theme.lightBlueBg : "#f6f6f6")};
  border-radius: 8px;
  border: 1px solid ${(p) => (p.isFocused ? theme.blueText : "#d8d8d8")};
  padding: 8px 12px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1;
`;

export const Label = styled.div<{ isFocused?: boolean }>`
  font-size: 12px;
  font-weight: 700;
  color: ${(p) => (p.isFocused ? theme.blueText : "#757575")};
  text-transform: uppercase;
`;

export const CountText = styled.div`
  font-size: 16px;
  font-weight: 900;
  color: #000000;
  line-height: 20px;
`;

export const HelpText = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #757575;
  line-height: 14px;
`;

export const CounterBox = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px solid #d8d8d8;
  border-radius: 8px;
  padding: 8px 12px;
  background: #ffffff;
  flex-shrink: 0;
`;

export const CounterButton = styled.button<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  background: none;
  cursor: ${(p) => (p.disabled ? "not-allowed" : "pointer")};
  opacity: ${(p) => (p.disabled ? 0.3 : 1)};
  padding: 0;
  -webkit-tap-highlight-color: transparent;
`;

export const CounterValue = styled.span`
  font-size: 16px;
  font-weight: 900;
  color: #000000;
  min-width: 20px;
  text-align: center;
`;

export const InlineInput = styled.input`
  font-size: 16px;
  font-weight: 900;
  color: #000000;
  border: none;
  background: transparent;
  outline: none;
  padding: 0;
  width: 100%;
  font-family: inherit;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  -moz-appearance: textfield;
`;

export const ValueRow = styled.div`
  display: flex;
  align-items: center;
`;
